import { createAction } from 'redux-actions';

import { urlTerminosYCondiciones, urlTerminosYCondicionesCheckUpdate } from '../urls';

import {
  getTermsAndConditionsMethod,
  updateTermsAndConditionsMethod,
} from './manageTermsAndConditionsMethods';

import { GET_TERMS_AND_CODITION, UPDATE_TERMS_AND_CODITION } from '../../constants';

export const getTermsAndConditions = createAction(
  GET_TERMS_AND_CODITION,
  getTermsAndConditionsMethod(urlTerminosYCondiciones),
);
export const updateTermsAndConditions = createAction(UPDATE_TERMS_AND_CODITION, (updateTerms) =>
  updateTermsAndConditionsMethod(urlTerminosYCondicionesCheckUpdate, updateTerms)(),
);
